import {gql} from '@apollo/client'

export const SEND_STATEMENT_EMAIL = gql`
  mutation SendStatementEmail(
    $accountId: ID!
    $to: String
    $cc: String
    $bcc: String
    $subject: String
    $message: String
    $fromDate: String
    $toDate: String
  ) {
    sendStatementEmail(
      accountId: $accountId
      to: $to
      cc: $cc
      bcc: $bcc
      subject: $subject
      message: $message
      fromDate: $fromDate
      toDate: $toDate
    ) {
      id
    }
  }
`

export const GET_STATEMENT = gql`
  query GetStatement(
    $accountId: ID!
    $fromDate: String
    $toDate: String
    $page: Int
    $limit: Int
    $sortDirection: String
  ) {
    statement(
      accountId: $accountId
      fromDate: $fromDate
      toDate: $toDate
      page: $page
      limit: $limit
      sortDirection: $sortDirection
    ) {
      collection {
        id
        date
        dateSettled
        amount
        balance
        state
        xeroLink
        ... on Invoice {
          description @client
          lineItems
          dueDate
          invoiceNumber
          reference
          isSent
          isSendable
        }
        ... on Payment {
          description
          reconciledAt
        }
        ... on Credit {
          description
        }
        ... on Debit {
          description
        }
      }
      metadata {
        totalCount
      }
    }
  }
`
